import { makeStyles } from "@material-ui/styles";

const barlowStyles = makeStyles(() => ({
	"@font-face": [
		{
			fontFamily: "'Barlow Condensed'",
			fontStyle: "italic",
			fontWeight: 100,
			fontDisplay: "swap",
			src: "url(https://fonts.gstatic.com/s/barlowcondensed/v12/HTxzL3I-JCGChYJ8VI-L6OO_au7B6xTru2H-nKwpaLJM_5k.woff2) format('woff2')",
			unicodeRange:
				"U+0102-0103, U+0110-0111, U+0128-0129, U+0168-0169, U+01A0-01A1, U+01AF-01B0, U+1EA0-1EF9, U+20AB"
		},
		{
			fontFamily: "'Barlow Condensed'",
			fontStyle: "italic",
			fontWeight: 100,
			fontDisplay: "swap",
			src: "url(https://fonts.gstatic.com/s/barlowcondensed/v12/HTxzL3I-JCGChYJ8VI-L6OO_au7B6xTru2H_nKwpaLJM_5k.woff2) format('woff2')",
			unicodeRange:
				"U+0100-024F, U+0259, U+1E00-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF"
		},
		{
			fontFamily: "'Barlow Condensed'",
			fontStyle: "italic",
			fontWeight: 100,
			fontDisplay: "swap",
			src: "url(https://fonts.gstatic.com/s/barlowcondensed/v12/HTxzL3I-JCGChYJ8VI-L6OO_au7B6xTru2HxnKwpaLJM.woff2) format('woff2')",
			unicodeRange:
				"U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
		},
		{
			fontFamily: "'Barlow Condensed'",
			fontStyle: "italic",
			fontWeight: 200,
			fontDisplay: "swap",
			src: "url(https://fonts.gstatic.com/s/barlowcondensed/v12/HTxyL3I-JCGChYJ8VI-L6OO_au7B6xTrF3DmtIkGQLhEx6A5.woff2) format('woff2')",
			unicodeRange:
				"U+0102-0103, U+0110-0111, U+0128-0129, U+0168-0169, U+01A0-01A1, U+01AF-01B0, U+1EA0-1EF9, U+20AB"
		},
		{
			fontFamily: "'Barlow Condensed'",
			fontStyle: "italic",
			fontWeight: 200,
			fontDisplay: "swap",
			src: "url(https://fonts.gstatic.com/s/barlowcondensed/v12/HTxyL3I-JCGChYJ8VI-L6OO_au7B6xTrF3DmtYkGQLhEx6A5.woff2) format('woff2')",
			unicodeRange:
				"U+0100-024F, U+0259, U+1E00-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF"
		},
		{
			fontFamily: "'Barlow Condensed'",
			fontStyle: "italic",
			fontWeight: 200,
			fontDisplay: "swap",
			src: "url(https://fonts.gstatic.com/s/barlowcondensed/v12/HTxyL3I-JCGChYJ8VI-L6OO_au7B6xTrF3Dmu4kGQLhExw.woff2) format('woff2')",
			unicodeRange:
				"U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
		},
		{
			fontFamily: "'Barlow Condensed'",
			fontStyle: "italic",
			fontWeight: 300,
			fontDisplay: "swap",
			src: "url(https://fonts.gstatic.com/s/barlowcondensed/v12/HTxyL3I-JCGChYJ8VI-L6OO_au7B6xTrc3PmtIkGQLhEx6A5.woff2) format('woff2')",
			unicodeRange:
				"U+0102-0103, U+0110-0111, U+0128-0129, U+0168-0169, U+01A0-01A1, U+01AF-01B0, U+1EA0-1EF9, U+20AB"
		},
		{
			fontFamily: "'Barlow Condensed'",
			fontStyle: "italic",
			fontWeight: 300,
			fontDisplay: "swap",
			src: "url(https://fonts.gstatic.com/s/barlowcondensed/v12/HTxyL3I-JCGChYJ8VI-L6OO_au7B6xTrc3PmtYkGQLhEx6A5.woff2) format('woff2')",
			unicodeRange:
				"U+0100-024F, U+0259, U+1E00-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF"
		},
		{
			fontFamily: "'Barlow Condensed'",
			fontStyle: "italic",
			fontWeight: 300,
			fontDisplay: "swap",
			src: "url(https://fonts.gstatic.com/s/barlowcondensed/v12/HTxyL3I-JCGChYJ8VI-L6OO_au7B6xTrc3Pmu4kGQLhExw.woff2) format('woff2')",
			unicodeRange:
				"U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
		},
		{
			fontFamily: "'Barlow Condensed'",
			fontStyle: "italic",
			fontWeight: 400,
			fontDisplay: "swap",
			src: "url(https://fonts.gstatic.com/s/barlowcondensed/v12/HTxxL3I-JCGChYJ8VI-L6OO_au7B6xTj11HzlqsLaoJN.woff2) format('woff2')",
			unicodeRange:
				"U+0102-0103, U+0110-0111, U+0128-0129, U+0168-0169, U+01A0-01A1, U+01AF-01B0, U+1EA0-1EF9, U+20AB"
		},
		{
			fontFamily: "'Barlow Condensed'",
			fontStyle: "italic",
			fontWeight: 400,
			fontDisplay: "swap",
			src: "url(https://fonts.gstatic.com/s/barlowcondensed/v12/HTxxL3I-JCGChYJ8VI-L6OO_au7B6xTj1lHzlqsLaoJN.woff2) format('woff2')",
			unicodeRange:
				"U+0100-024F, U+0259, U+1E00-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF"
		},
		{
			fontFamily: "'Barlow Condensed'",
			fontStyle: "italic",
			fontWeight: 400,
			fontDisplay: "swap",
			src: "url(https://fonts.gstatic.com/s/barlowcondensed/v12/HTxxL3I-JCGChYJ8VI-L6OO_au7B6xTj2FHzlqsLag.woff2) format('woff2')",
			unicodeRange:
				"U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
		},
		{
			fontFamily: "'Barlow Condensed'",
			fontStyle: "italic",
			fontWeight: 600,
			fontDisplay: "swap",
			src: "url(https://fonts.gstatic.com/s/barlowcondensed/v12/HTxyL3I-JCGChYJ8VI-L6OO_au7B6xTrB3XmtIkGQLhEx6A5.woff2) format('woff2')",
			unicodeRange:
				"U+0102-0103, U+0110-0111, U+0128-0129, U+0168-0169, U+01A0-01A1, U+01AF-01B0, U+1EA0-1EF9, U+20AB"
		},
		{
			fontFamily: "'Barlow Condensed'",
			fontStyle: "italic",
			fontWeight: 600,
			fontDisplay: "swap",
			src: "url(https://fonts.gstatic.com/s/barlowcondensed/v12/HTxyL3I-JCGChYJ8VI-L6OO_au7B6xTrB3XmtYkGQLhEx6A5.woff2) format('woff2')",
			unicodeRange:
				"U+0100-024F, U+0259, U+1E00-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF"
		},
		{
			fontFamily: "'Barlow Condensed'",
			fontStyle: "italic",
			fontWeight: 600,
			fontDisplay: "swap",
			src: "url(https://fonts.gstatic.com/s/barlowcondensed/v12/HTxyL3I-JCGChYJ8VI-L6OO_au7B6xTrB3Xmu4kGQLhExw.woff2) format('woff2')",
			unicodeRange:
				"U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
		},
		{
			fontFamily: "'Barlow Condensed'",
			fontStyle: "italic",
			fontWeight: 700,
			fontDisplay: "swap",
			src: "url(https://fonts.gstatic.com/s/barlowcondensed/v12/HTxyL3I-JCGChYJ8VI-L6OO_au7B6xTrY3TmtIkGQLhEx6A5.woff2) format('woff2')",
			unicodeRange:
				"U+0102-0103, U+0110-0111, U+0128-0129, U+0168-0169, U+01A0-01A1, U+01AF-01B0, U+1EA0-1EF9, U+20AB"
		},
		{
			fontFamily: "'Barlow Condensed'",
			fontStyle: "italic",
			fontWeight: 700,
			fontDisplay: "swap",
			src: "url(https://fonts.gstatic.com/s/barlowcondensed/v12/HTxyL3I-JCGChYJ8VI-L6OO_au7B6xTrY3TmtYkGQLhEx6A5.woff2) format('woff2')",
			unicodeRange:
				"U+0100-024F, U+0259, U+1E00-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF"
		},
		{
			fontFamily: "'Barlow Condensed'",
			fontStyle: "italic",
			fontWeight: 700,
			fontDisplay: "swap",
			src: "url(https://fonts.gstatic.com/s/barlowcondensed/v12/HTxyL3I-JCGChYJ8VI-L6OO_au7B6xTrY3Tmu4kGQLhExw.woff2) format('woff2')",
			unicodeRange:
				"U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
		},
		{
			fontFamily: "'Barlow Condensed'",
			fontStyle: "italic",
			fontWeight: 800,
			fontDisplay: "swap",
			src: "url(https://fonts.gstatic.com/s/barlowcondensed/v12/HTxyL3I-JCGChYJ8VI-L6OO_au7B6xTrf3fmtIkGQLhEx6A5.woff2) format('woff2')",
			unicodeRange:
				"U+0102-0103, U+0110-0111, U+0128-0129, U+0168-0169, U+01A0-01A1, U+01AF-01B0, U+1EA0-1EF9, U+20AB"
		},
		{
			fontFamily: "'Barlow Condensed'",
			fontStyle: "italic",
			fontWeight: 800,
			fontDisplay: "swap",
			src: "url(https://fonts.gstatic.com/s/barlowcondensed/v12/HTxyL3I-JCGChYJ8VI-L6OO_au7B6xTrf3fmtYkGQLhEx6A5.woff2) format('woff2')",
			unicodeRange:
				"U+0100-024F, U+0259, U+1E00-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF"
		},
		{
			fontFamily: "'Barlow Condensed'",
			fontStyle: "italic",
			fontWeight: 800,
			fontDisplay: "swap",
			src: "url(https://fonts.gstatic.com/s/barlowcondensed/v12/HTxyL3I-JCGChYJ8VI-L6OO_au7B6xTrf3fmu4kGQLhExw.woff2) format('woff2')",
			unicodeRange:
				"U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
		},
		{
			fontFamily: "'Barlow Condensed'",
			fontStyle: "italic",
			fontWeight: 900,
			fontDisplay: "swap",
			src: "url(https://fonts.gstatic.com/s/barlowcondensed/v12/HTxyL3I-JCGChYJ8VI-L6OO_au7B6xTrW3bmtIkGQLhEx6A5.woff2) format('woff2')",
			unicodeRange:
				"U+0102-0103, U+0110-0111, U+0128-0129, U+0168-0169, U+01A0-01A1, U+01AF-01B0, U+1EA0-1EF9, U+20AB"
		},
		{
			fontFamily: "'Barlow Condensed'",
			fontStyle: "italic",
			fontWeight: 900,
			fontDisplay: "swap",
			src: "url(https://fonts.gstatic.com/s/barlowcondensed/v12/HTxyL3I-JCGChYJ8VI-L6OO_au7B6xTrW3bmtYkGQLhEx6A5.woff2) format('woff2')",
			unicodeRange:
				"U+0100-024F, U+0259, U+1E00-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF"
		},
		{
			fontFamily: "'Barlow Condensed'",
			fontStyle: "italic",
			fontWeight: 900,
			fontDisplay: "swap",
			src: "url(https://fonts.gstatic.com/s/barlowcondensed/v12/HTxyL3I-JCGChYJ8VI-L6OO_au7B6xTrW3bmu4kGQLhExw.woff2) format('woff2')",
			unicodeRange:
				"U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
		},
		{
			fontFamily: "'Barlow Condensed'",
			fontStyle: "normal",
			fontWeight: 100,
			fontDisplay: "swap",
			src: "url(https://fonts.gstatic.com/s/barlowcondensed/v12/HTxxL3I-JCGChYJ8VI-L6OO_au7B43Lj11HzlqsLaoJN.woff2) format('woff2')",
			unicodeRange:
				"U+0102-0103, U+0110-0111, U+0128-0129, U+0168-0169, U+01A0-01A1, U+01AF-01B0, U+1EA0-1EF9, U+20AB"
		},
		{
			fontFamily: "'Barlow Condensed'",
			fontStyle: "normal",
			fontWeight: 100,
			fontDisplay: "swap",
			src: "url(https://fonts.gstatic.com/s/barlowcondensed/v12/HTxxL3I-JCGChYJ8VI-L6OO_au7B43Lj1lHzlqsLaoJN.woff2) format('woff2')",
			unicodeRange:
				"U+0100-024F, U+0259, U+1E00-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF"
		},
		{
			fontFamily: "'Barlow Condensed'",
			fontStyle: "normal",
			fontWeight: 100,
			fontDisplay: "swap",
			src: "url(https://fonts.gstatic.com/s/barlowcondensed/v12/HTxxL3I-JCGChYJ8VI-L6OO_au7B43Lj2FHzlqsLag.woff2) format('woff2')",
			unicodeRange:
				"U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
		},
		{
			fontFamily: "'Barlow Condensed'",
			fontStyle: "normal",
			fontWeight: 200,
			fontDisplay: "swap",
			src: "url(https://fonts.gstatic.com/s/barlowcondensed/v12/HTxwL3I-JCGChYJ8VI-L6OO_au7B497yz3nWuYMBYrp0xg.woff2) format('woff2')",
			unicodeRange:
				"U+0102-0103, U+0110-0111, U+0128-0129, U+0168-0169, U+01A0-01A1, U+01AF-01B0, U+1EA0-1EF9, U+20AB"
		},
		{
			fontFamily: "'Barlow Condensed'",
			fontStyle: "normal",
			fontWeight: 200,
			fontDisplay: "swap",
			src: "url(https://fonts.gstatic.com/s/barlowcondensed/v12/HTxwL3I-JCGChYJ8VI-L6OO_au7B497yz3jWuYMBYrp0xg.woff2) format('woff2')",
			unicodeRange:
				"U+0100-024F, U+0259, U+1E00-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF"
		},
		{
			fontFamily: "'Barlow Condensed'",
			fontStyle: "normal",
			fontWeight: 200,
			fontDisplay: "swap",
			src: "url(https://fonts.gstatic.com/s/barlowcondensed/v12/HTxwL3I-JCGChYJ8VI-L6OO_au7B497yz3bWuYMBYro.woff2) format('woff2')",
			unicodeRange:
				"U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
		},
		{
			fontFamily: "'Barlow Condensed'",
			fontStyle: "normal",
			fontWeight: 300,
			fontDisplay: "swap",
			src: "url(https://fonts.gstatic.com/s/barlowcondensed/v12/HTxwL3I-JCGChYJ8VI-L6OO_au7B47rxz3nWuYMBYrp0xg.woff2) format('woff2')",
			unicodeRange:
				"U+0102-0103, U+0110-0111, U+0128-0129, U+0168-0169, U+01A0-01A1, U+01AF-01B0, U+1EA0-1EF9, U+20AB"
		},
		{
			fontFamily: "'Barlow Condensed'",
			fontStyle: "normal",
			fontWeight: 300,
			fontDisplay: "swap",
			src: "url(https://fonts.gstatic.com/s/barlowcondensed/v12/HTxwL3I-JCGChYJ8VI-L6OO_au7B47rxz3jWuYMBYrp0xg.woff2) format('woff2')",
			unicodeRange:
				"U+0100-024F, U+0259, U+1E00-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF"
		},
		{
			fontFamily: "'Barlow Condensed'",
			fontStyle: "normal",
			fontWeight: 300,
			fontDisplay: "swap",
			src: "url(https://fonts.gstatic.com/s/barlowcondensed/v12/HTxwL3I-JCGChYJ8VI-L6OO_au7B47rxz3bWuYMBYro.woff2) format('woff2')",
			unicodeRange:
				"U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
		},
		{
			fontFamily: "'Barlow Condensed'",
			fontStyle: "normal",
			fontWeight: 400,
			fontDisplay: "swap",
			src: "url(https://fonts.gstatic.com/s/barlowcondensed/v12/HTx3L3I-JCGChYJ8VI-L6OO_au7B6x7T2lv0tKk7aw.woff2) format('woff2')",
			unicodeRange:
				"U+0102-0103, U+0110-0111, U+0128-0129, U+0168-0169, U+01A0-01A1, U+01AF-01B0, U+1EA0-1EF9, U+20AB"
		},
		{
			fontFamily: "'Barlow Condensed'",
			fontStyle: "normal",
			fontWeight: 400,
			fontDisplay: "swap",
			src: "url(https://fonts.gstatic.com/s/barlowcondensed/v12/HTx3L3I-JCGChYJ8VI-L6OO_au7B6x_T2lv0tKk7aw.woff2) format('woff2')",
			unicodeRange:
				"U+0100-024F, U+0259, U+1E00-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF"
		},
		{
			fontFamily: "'Barlow Condensed'",
			fontStyle: "normal",
			fontWeight: 400,
			fontDisplay: "swap",
			src: "url(https://fonts.gstatic.com/s/barlowcondensed/v12/HTx3L3I-JCGChYJ8VI-L6OO_au7B6xHT2lv0tKk.woff2) format('woff2')",
			unicodeRange:
				"U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
		},
		{
			fontFamily: "'Barlow Condensed'",
			fontStyle: "normal",
			fontWeight: 500,
			fontDisplay: "swap",
			src: "url(https://fonts.gstatic.com/s/barlowcondensed/v12/HTxwL3I-JCGChYJ8VI-L6OO_au7B4-Lwz3nWuYMBYrp0xg.woff2) format('woff2')",
			unicodeRange:
				"U+0102-0103, U+0110-0111, U+0128-0129, U+0168-0169, U+01A0-01A1, U+01AF-01B0, U+1EA0-1EF9, U+20AB"
		},
		{
			fontFamily: "'Barlow Condensed'",
			fontStyle: "normal",
			fontWeight: 500,
			fontDisplay: "swap",
			src: "url(https://fonts.gstatic.com/s/barlowcondensed/v12/HTxwL3I-JCGChYJ8VI-L6OO_au7B4-Lwz3jWuYMBYrp0xg.woff2) format('woff2')",
			unicodeRange:
				"U+0100-024F, U+0259, U+1E00-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF"
		},
		{
			fontFamily: "'Barlow Condensed'",
			fontStyle: "normal",
			fontWeight: 500,
			fontDisplay: "swap",
			src: "url(https://fonts.gstatic.com/s/barlowcondensed/v12/HTxwL3I-JCGChYJ8VI-L6OO_au7B4-Lwz3bWuYMBYro.woff2) format('woff2')",
			unicodeRange:
				"U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
		},
		{
			fontFamily: "'Barlow Condensed'",
			fontStyle: "normal",
			fontWeight: 600,
			fontDisplay: "swap",
			src: "url(https://fonts.gstatic.com/s/barlowcondensed/v12/HTxwL3I-JCGChYJ8VI-L6OO_au7B4873z3nWuYMBYrp0xg.woff2) format('woff2')",
			unicodeRange:
				"U+0102-0103, U+0110-0111, U+0128-0129, U+0168-0169, U+01A0-01A1, U+01AF-01B0, U+1EA0-1EF9, U+20AB"
		},
		{
			fontFamily: "'Barlow Condensed'",
			fontStyle: "normal",
			fontWeight: 600,
			fontDisplay: "swap",
			src: "url(https://fonts.gstatic.com/s/barlowcondensed/v12/HTxwL3I-JCGChYJ8VI-L6OO_au7B4873z3jWuYMBYrp0xg.woff2) format('woff2')",
			unicodeRange:
				"U+0100-024F, U+0259, U+1E00-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF"
		},
		{
			fontFamily: "'Barlow Condensed'",
			fontStyle: "normal",
			fontWeight: 600,
			fontDisplay: "swap",
			src: "url(https://fonts.gstatic.com/s/barlowcondensed/v12/HTxwL3I-JCGChYJ8VI-L6OO_au7B4873z3bWuYMBYro.woff2) format('woff2')",
			unicodeRange:
				"U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
		},
		{
			fontFamily: "'Barlow Condensed'",
			fontStyle: "normal",
			fontWeight: 700,
			fontDisplay: "swap",
			src: "url(https://fonts.gstatic.com/s/barlowcondensed/v12/HTxwL3I-JCGChYJ8VI-L6OO_au7B46r2z3nWuYMBYrp0xg.woff2) format('woff2')",
			unicodeRange:
				"U+0102-0103, U+0110-0111, U+0128-0129, U+0168-0169, U+01A0-01A1, U+01AF-01B0, U+1EA0-1EF9, U+20AB"
		},
		{
			fontFamily: "'Barlow Condensed'",
			fontStyle: "normal",
			fontWeight: 700,
			fontDisplay: "swap",
			src: "url(https://fonts.gstatic.com/s/barlowcondensed/v12/HTxwL3I-JCGChYJ8VI-L6OO_au7B46r2z3jWuYMBYrp0xg.woff2) format('woff2')",
			unicodeRange:
				"U+0100-024F, U+0259, U+1E00-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF"
		},
		{
			fontFamily: "'Barlow Condensed'",
			fontStyle: "normal",
			fontWeight: 700,
			fontDisplay: "swap",
			src: "url(https://fonts.gstatic.com/s/barlowcondensed/v12/HTxwL3I-JCGChYJ8VI-L6OO_au7B46r2z3bWuYMBYro.woff2) format('woff2')",
			unicodeRange:
				"U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
		},
		{
			fontFamily: "'Barlow Condensed'",
			fontStyle: "normal",
			fontWeight: 800,
			fontDisplay: "swap",
			src: "url(https://fonts.gstatic.com/s/barlowcondensed/v12/HTxwL3I-JCGChYJ8VI-L6OO_au7B47b1z3nWuYMBYrp0xg.woff2) format('woff2')",
			unicodeRange:
				"U+0102-0103, U+0110-0111, U+0128-0129, U+0168-0169, U+01A0-01A1, U+01AF-01B0, U+1EA0-1EF9, U+20AB"
		},
		{
			fontFamily: "'Barlow Condensed'",
			fontStyle: "normal",
			fontWeight: 800,
			fontDisplay: "swap",
			src: "url(https://fonts.gstatic.com/s/barlowcondensed/v12/HTxwL3I-JCGChYJ8VI-L6OO_au7B47b1z3jWuYMBYrp0xg.woff2) format('woff2')",
			unicodeRange:
				"U+0100-024F, U+0259, U+1E00-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF"
		},
		{
			fontFamily: "'Barlow Condensed'",
			fontStyle: "normal",
			fontWeight: 800,
			fontDisplay: "swap",
			src: "url(https://fonts.gstatic.com/s/barlowcondensed/v12/HTxwL3I-JCGChYJ8VI-L6OO_au7B47b1z3bWuYMBYro.woff2) format('woff2')",
			unicodeRange:
				"U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
		},
		{
			fontFamily: "'Barlow Condensed'",
			fontStyle: "normal",
			fontWeight: 900,
			fontDisplay: "swap",
			src: "url(https://fonts.gstatic.com/s/barlowcondensed/v12/HTxwL3I-JCGChYJ8VI-L6OO_au7B45L0z3nWuYMBYrp0xg.woff2) format('woff2')",
			unicodeRange:
				"U+0102-0103, U+0110-0111, U+0128-0129, U+0168-0169, U+01A0-01A1, U+01AF-01B0, U+1EA0-1EF9, U+20AB"
		},
		{
			fontFamily: "'Barlow Condensed'",
			fontStyle: "normal",
			fontWeight: 900,
			fontDisplay: "swap",
			src: "url(https://fonts.gstatic.com/s/barlowcondensed/v12/HTxwL3I-JCGChYJ8VI-L6OO_au7B45L0z3jWuYMBYrp0xg.woff2) format('woff2')",
			unicodeRange:
				"U+0100-024F, U+0259, U+1E00-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF"
		},
		{
			fontFamily: "'Barlow Condensed'",
			fontStyle: "normal",
			fontWeight: 900,
			fontDisplay: "swap",
			src: "url(https://fonts.gstatic.com/s/barlowcondensed/v12/HTxwL3I-JCGChYJ8VI-L6OO_au7B45L0z3bWuYMBYro.woff2) format('woff2')",
			unicodeRange:
				"U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
		}
	]
}));

export default barlowStyles;
